import React from "react";

const defaultCellWidths = ["7rem", "9rem", "8rem", "10rem", "7rem", "5rem"];

const TableSkeletonRow = ({
  idx,
  rowKeyPrefix = "skeleton-row",
  columnCount = 3,
  actionColumnIndex,
  cellWidths,
  actionAlign = "center",
  actionJustify = "center",
  actionSkeletonCount = 2,
}) => {
  const resolvedColumnCount = Number.isInteger(columnCount) && columnCount > 0 ? columnCount : 3;
  const resolvedActionColumnIndex =
    Number.isInteger(actionColumnIndex) &&
    actionColumnIndex >= 0 &&
    actionColumnIndex < resolvedColumnCount
      ? actionColumnIndex
      : resolvedColumnCount - 1;

  const getCellWidth = (colIdx) => {
    if (Array.isArray(cellWidths) && cellWidths[colIdx]) {
      return cellWidths[colIdx];
    }
    return defaultCellWidths[colIdx % defaultCellWidths.length];
  };

  return (
    <tr
      key={`${rowKeyPrefix}-${idx}`}
      style={{
        background: idx % 2 === 0 ? "#ffffff" : "#f3f0f7",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        border: "1px solid #e5e5e5",
      }}
    >
      {Array.from({ length: resolvedColumnCount }).map((_, colIdx) => {
        const isFirst = colIdx === 0;
        const isLast = colIdx === resolvedColumnCount - 1;
        const isActionCell = colIdx === resolvedActionColumnIndex;

        return (
          <td
            key={`${rowKeyPrefix}-${idx}-${colIdx}`}
            style={{
              padding: "14px 16px",
              ...(isFirst ? { borderRadius: "8px 0 0 8px" } : {}),
              ...(isLast ? { borderRadius: "0 8px 8px 0" } : {}),
              ...(isActionCell ? { textAlign: actionAlign } : {}),
            }}
          >
            {isActionCell ? (
              <div className={`flex gap-2 justify-${actionJustify}`}>
                {Array.from({ length: actionSkeletonCount }).map((__, actionIdx) => (
                  <div
                    key={`${rowKeyPrefix}-${idx}-${colIdx}-action-${actionIdx}`}
                    className="h-8 bg-gray-300 rounded animate-pulse"
                    style={{ width: "5rem" }}
                  />
                ))}
              </div>
            ) : (
              <div
                className="h-4 bg-gray-300 rounded animate-pulse"
                style={{ width: getCellWidth(colIdx) }}
              />
            )}
          </td>
        );
      })}
    </tr>
  );
};

export default TableSkeletonRow;